<template>
  <div>
    <div class="banner bg-agora"></div>
    <div class="mosaic-container">
      <div class="mosaic-grid">
        <img 
          v-for="(img, index) in shuffledImages" 
          :key="img.url + index"
          :src="img.url" 
          :alt="img.name" 
          loading="lazy" 
          :class="['mosaic-item', 'border-md', img.sizeClass]"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MosaicCollage",
  data() {
    return {
      shuffledImages: []
    }
  },
  mounted() {
    this.initGallery()
  },
  methods: {
    initGallery() {
      const bookContext = require.context('@/assets/Images/books/More', false, /\.(png|jpe?g|svg)$/i)
      const authorContext = require.context('@/assets/Images/authors/More', false, /\.(png|jpe?g|svg)$/i)

      const books = bookContext.keys().map(key => ({
        url: bookContext(key),
        name: key.split('/').pop().replace(/\.[^/.]+$/, "")
      }))

      const authors = authorContext.keys().map(key => ({
        url: authorContext(key),
        name: key.split('/').pop().replace(/\.[^/.]+$/, "")
      }))

      let allImages = [...books, ...authors]
      let shuffled = this.shuffle(allImages)

      this.shuffledImages = shuffled.map(img => ({
        ...img,
        sizeClass: this.getSizeClass()
      }))
    },

    shuffle(array) {
      const arr = [...array]
      for (let i = arr.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1))
        ;[arr[i], arr[j]] = [arr[j], arr[i]]
      }
      return arr
    },

    getSizeClass() {
      const rand = Math.random()
      // 5 Sizes Distribution:
      if (rand < 0.10) return 'size-xl'  // 10% Extra Large (5x5)
      if (rand < 0.25) return 'size-lg'  // 15% Large (4x4)
      if (rand < 0.50) return 'size-md'  // 25% Medium (3x3)
      if (rand < 0.80) return 'size-nm'  // 30% Normal (2x2)
      return 'size-sm'                   // 20% Small (1x1)
    }
  }
}
</script>

<style scoped>
.mosaic-container {
  padding: 40px 0; /* Vertical padding only, let grid handle horizontal */
  background-color: #f8f4ed;
  width: 100%;
  display: flex;
  justify-content: center;
}

.mosaic-grid {
  /* Base size is the smallest unit (1x1). 
     Reduced slightly to allow more "packing" flexibility. 
  */
  --unit: clamp(40px, 6vw, 70px);
  --gap: clamp(8px, 1.5vw, 16px);

  display: grid;
  /* Using auto-fit and justify-content: center together prevents 
     the "left-leaning" look by centering the entire block of tracks. 
  */
  grid-template-columns: repeat(auto-fit, var(--unit));
  grid-auto-rows: var(--unit);
  grid-auto-flow: dense; 
  
  gap: var(--unit); /* High gap creates a very airy, artistic look */
  /* Or use the variable for a tighter fit: */
  gap: var(--gap);

  width: 95%; /* Margin of safety for the viewport */
  max-width: 1800px;
  justify-content: center; /* This is the fix for the left/right push */
}

.mosaic-item {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease;
}

/* 5 Tiers - All Strictly 1:1 
   The unit determines the size, so span 1 = unit * 1, span 2 = unit * 2, etc.
*/
.size-sm { grid-column: span 1; grid-row: span 1; }
.size-nm { grid-column: span 2; grid-row: span 2; }
.size-md { grid-column: span 3; grid-row: span 3; }
.size-lg { grid-column: span 4; grid-row: span 4; }
.size-xl { grid-column: span 5; grid-row: span 5; }

/* Responsive adjustments for smaller screens */
@media (max-width: 768px) {
  .size-xl, .size-lg { 
    grid-column: span 3; 
    grid-row: span 3; 
  }
}
</style>